// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"9607f628","566":"f132985e","610":"79a8c9ca","656":"f97592dd","852":"14d358e0","954":"a2b7f331"}[chunkId] + ".chunk.css";
};